import { withStyles, WithStyles } from "@mui/styles";
import { DashboardStyleClasses } from "assets/jss/common-styles";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import * as React from "react";
import UserAndGroupsFilter from "views/Dashboards/UserAndGroupsDashboard/UserAndGroupsFilter";
import UserAndGroupsKnowledgeDashboard from "views/Dashboards/UserAndGroupsDashboard/UserAndGroupsKnowledgeDashboard";
import UserAndGroupsParticipationDashboard from "views/Dashboards/UserAndGroupsDashboard/UserAndGroupsParticipationDashboard";
import { TabOptions } from "views/Dashboards/UserAndGroupsDashboard/UserAndGroupsTabs";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    currentTab: TabOptions;
}

type Props = {} & WithStyles<typeof DashboardStyleClasses> & WithSnackbar;

/////////////////////////////////////////////////////////////////////////////////////

class UserAndGroupsDashboard extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: TabOptions.Participation,
        };
    }

    ///
    private handleTabSelection = (value: TabOptions) => {
        this.setState({ currentTab: value });
    }


    ///
    render() {
        const { currentTab } = this.state;

        return (
            <div className={this.props.classes.dashboardLargeContainer}>

                {
                    currentTab == TabOptions.Participation
                        ? <UserAndGroupsParticipationDashboard onTabChange={this.handleTabSelection} filterComponent={UserAndGroupsFilter} managerTeamMode={false} />
                        : currentTab == TabOptions.Knowledge
                            ? <UserAndGroupsKnowledgeDashboard onTabChange={this.handleTabSelection} filterComponent={UserAndGroupsFilter} managerTeamMode={false} />
                            : null
                }

            </div>
        );
    }
}

export default withSnackbar(withStyles(DashboardStyleClasses)(UserAndGroupsDashboard));

////////////////////////////////////////////////////////////////////////////////////////////////////
